import { render, staticRenderFns } from "./DsfExtract.vue?vue&type=template&id=d33ffbca&"
import script from "./DsfExtract.vue?vue&type=script&lang=js&"
export * from "./DsfExtract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports